"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class OrganisationInvite extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'organisationInvite';
        this._orgPermission = initParams.org_permission;
        this._emailAddress = initParams.email_address;
        this._inviteSent = initParams.invite_sent;
        this._linkOpened = initParams.link_opened;
        this._orgName = initParams.org_name;
        this._orgId = initParams.org_id;
        this._orgOverridePerms = initParams.org_override_perms;
        this._sitesLimitedTo = (0, util_1.camelArray)(initParams.sites_limited_to);
    }
    set orgPermission(value) {
        console.error('Do not set objects this way');
    }
    setOrgPermission(value) {
        return this.dataService.updateOrganisationInvite(this.id, { org_permission: value }, this);
    }
    get orgPermission() {
        return this._orgPermission;
    }
    set emailAddress(value) {
        console.error('Do not set objects this way');
    }
    setEmailAddress(value) {
        return this.dataService.updateOrganisationInvite(this.id, { email_address: value }, this);
    }
    get emailAddress() {
        return this._emailAddress;
    }
    set inviteSent(value) {
        console.error('Do not set objects this way');
    }
    setInviteSent(value) {
        return this.dataService.updateOrganisationInvite(this.id, { invite_sent: value }, this);
    }
    get inviteSent() {
        return this._inviteSent;
    }
    set linkOpened(value) {
        console.error('Do not set objects this way');
    }
    setLinkOpened(value) {
        return this.dataService.updateOrganisationInvite(this.id, { link_opened: value }, this);
    }
    get linkOpened() {
        return this._linkOpened;
    }
    set orgName(value) {
        console.error('Do not set objects this way');
    }
    setOrgName(value) {
        return this.dataService.updateOrganisationInvite(this.id, { org_name: value }, this);
    }
    get orgName() {
        return this._orgName;
    }
    set orgId(value) {
        console.error('Do not set objects this way');
    }
    setOrgId(value) {
        return this.dataService.updateOrganisationInvite(this.id, { org_id: value }, this);
    }
    get orgId() {
        return this._orgId;
    }
    set orgOverridePerms(value) {
        console.error('Do not set objects this way');
    }
    setOrgOverridePerms(value) {
        return this.dataService.updateOrganisationInvite(this.id, { org_override_perms: value }, this);
    }
    get orgOverridePerms() {
        return this._orgOverridePerms;
    }
    set sitesLimitedTo(value) {
        console.error('Do not set objects this way');
    }
    setSitesLimitedTo(value) {
        return this.dataService.updateOrganisationInvite(this.id, { sites_limited_to: (0, util_1.snakeArray)(value) }, this);
    }
    get sitesLimitedTo() {
        return this._sitesLimitedTo;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateOrganisationInvite(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteOrganisationInvite(this.id, this);
    }
}
exports.default = OrganisationInvite;
//# sourceMappingURL=organisationInvite.js.map